import { render, staticRenderFns } from "./financial-preview.vue?vue&type=template&id=06d1a96c&scoped=true&"
import script from "./financial-preview.vue?vue&type=script&lang=js&"
export * from "./financial-preview.vue?vue&type=script&lang=js&"
import style0 from "./financial-preview.vue?vue&type=style&index=0&id=06d1a96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1a96c",
  null
  
)

export default component.exports